module.exports = __webpack_public_path__ + "static/img/result.924c7115.png";